import { TerraDraw, TerraDrawPolygonMode, TerraDrawSelectMode } from 'terra-draw';
import { TerraDrawGoogleMapsAdapter } from 'terra-draw-google-maps-adapter';

interface PolygonMouseEvent extends google.maps.MapMouseEvent {
    vertex?: number;
    edge?: number;
    path?: number;
}

export class GeofenceDrawManager {
    private terraDraw!: TerraDraw;
    private polygonMode!: TerraDrawPolygonMode;
    private selectMode!: TerraDrawSelectMode;
    private activeFeatureId?: string | number;

    constructor(
        private map: google.maps.Map,
        public geofence: google.maps.Polygon | undefined
    ) {
        this.initializeTerraDraw();
    }

    private initializeTerraDraw() {
        this.polygonMode = new TerraDrawPolygonMode({});
        this.selectMode = new TerraDrawSelectMode({});

        this.terraDraw = new TerraDraw({
            adapter: new TerraDrawGoogleMapsAdapter({ map: this.map, lib: google.maps }),
            modes: [this.polygonMode, this.selectMode],
        });

        google.maps.event.addListenerOnce(this.map, 'idle', () => {
            this.terraDraw.start();
            this.terraDraw.setMode('polygon');
        });

        // Handle finish event to convert TerraDraw polygon to editable Google Maps polygon
        this.terraDraw.on('finish', (id) => {
            const feature = this.terraDraw.getSnapshot().find((f) => f.id === id);
            if (!feature || feature.geometry.type !== 'Polygon') return;

            const coords = feature.geometry.coordinates[0].map(([lng, lat]) => new google.maps.LatLng(lat, lng));

            // Remove previous editable polygon if exists
            if (this.geofence) this.geofence.setMap(null);

            // Create editable Google Maps polygon
            this.geofence = new google.maps.Polygon({
                paths: coords,
                editable: true,
                draggable: true,
                //fillColor: this.form.getItemValue('colour') || '#00AAFF',
                fillOpacity: 0.35,
                strokeColor: '#000000',
                strokeWeight: 2,
            });
            this.geofence.setMap(this.map);

            // Remove the TerraDraw feature from map so it doesn't render
            this.terraDraw.removeFeatures([id]);

            this.activeFeatureId = id;
        });
    }

    setMode(mode: 'polygon' | 'select') {
        if (mode === 'polygon') {
            this.terraDraw.setMode('polygon');
        } else if (mode === 'select') {
            this.terraDraw.setMode('select');

            this.geofence?.addListener('click', (e: PolygonMouseEvent) => {
                this.processClickEvent(e);
            });
        }
    }

    private processClickEvent(e: PolygonMouseEvent) {
        if (!this.geofence) {
            return;
        }
        if (e.vertex == null) {
            return;
        }
        // Only delete if Ctrl is held
        if (!(e.domEvent as MouseEvent).ctrlKey) {
            return;
        }

        const path = this.geofence?.getPath();
        // Don't allow fewer than 3 vertices
        if (path && path.getLength() <= 3) {
            return;
        }

        path?.removeAt(e.vertex);
    }
}
